/* eslint-disable no-unused-vars */
enum ActionTypes {
  HANDLE_CHANGE='HANDLE_CHANGE',
  HANDLE_CHANGE_SEARCH = 'HANDLE_CHANGE_SEARCH',
  DISPLAY_DIALOG = 'DISPLAY_DIALOG',
  HIDE_DIALOG = 'HIDE_DIALOG',
  HANDLE_CHANGE_INFO_BOOKING='HANDLE_CHANGE_INFO_BOOKING',
  HANDLE_RESET_CONTEXT = 'HANDLE_RESET_CONTEXT'
}

export default ActionTypes;
